import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ApiGetDataStatus, CustomerStateType } from '@redux/types'
import { Customer, CustomerType } from '@schemas'

// initial state
const initialState: CustomerStateType = {
	customerList: [],
	customerListStatus: 'init',
	editPasswordCustomer: new Customer(),
	resetPasswordErrorMessage: '',
	updateCustomer: {
		customerId: '',
		name: '',
		email: '',
		iudFlag: 'I',
		confirmEmailNewsYn: 0,
	},
	updateResetPassword: {
		customerId: '',
		password: '',
	},
	updateCustomerRoles: {
		customerId: '',
		roleCodes: [],
	},
	triggerInitCustomer: false,
}

const slice = createSlice({
	name: 'customer',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_CUSTOMER_PAGE: (
			state: CustomerStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitCustomer = action.payload
		},

		// customers
		CUSTOMER_LIST: (state: CustomerStateType, action: PayloadAction<CustomerType[]>) => {
			state.customerList = action.payload
		},
		CUSTOMER_LIST_STATUS: (
			state: CustomerStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.customerListStatus = action.payload
		},
		EDIT_PASSWORD_CUSTOMER: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['editPasswordCustomer']>,
		) => {
			state.editPasswordCustomer = action.payload
		},
		RESET_PASSWORD_ERROR_MESSAGE: (
			state: CustomerStateType,
			action: PayloadAction<string>,
		) => {
			state.resetPasswordErrorMessage = action.payload
		},
		UPDATE_RESET_PASSWORD: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['updateResetPassword']>,
		) => {
			state.updateResetPassword = action.payload
		},

		// 고객 유형(역할) 집합 저장 — saga 가 PUT /customer-role/{id} 를 부른다
		UPDATE_CUSTOMER_ROLES: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['updateCustomerRoles']>,
		) => {
			state.updateCustomerRoles = action.payload
		},

		// updateCustomer
		UPDATE_CUSTOMER: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['updateCustomer']>,
		) => {
			state.updateCustomer = action.payload
		},
	},
})

export default slice.reducer
export const customerActions = slice.actions
